// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folder-node label:before{
    /* content: url('../../assets/images//calendar.png'); */
    display: inline;
    font-family: FontAwesome;
    content: "\\f07b";
    margin-right: 2px;
    color: #ffc033;
}
.super-treeview > div > .super-treeview-node > .super-treeview-children-container{
    border-left: 1px dashed #000;
}
.super-treeview > div > .super-treeview-node > .super-treeview-node-content > label {
    text-overflow: initial;
    overflow: visible;
    overflow: initial;
    white-space: pre-wrap;
    font-size: 0.81rem;
}
.libraryTable {
    min-height:23rem;
}
.library {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}
.libraryContainer {
    width: 100%;
    background-color: white;
    min-height: 500px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
}
.thickRightBorder{
    border-right: 4px solid lightgray;
}
.bottomBorder {
    border-bottom: 1px solid lightgray;
}
.super-treeview {
    width: 99%;
}
.libraryTreeWrapper {
    min-height: 400px;
    max-height: 400px;
    overflow: auto;
}
.libRightPanel {
    width: 72%;
    border: 1px solid lightgrey;
    min-height: 760px!important;
}
.activeFolder {
    color:#e50000 !important;
}
.libraryRoot {
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.black-font {
    color: black!important;
}
.lib-add-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
    margin-left: 0.75rem !important;
    margin-top: 0px!important;
}
.button-addfile-toyota {
    background-color: #e50000;
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 1rem;
    padding: -0.9rem 0.6rem;
    height: 1.5rem;
    font-size: 14px;

}
.button-downloadfile-toyota {
    background-color: blue;
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 1rem;
    padding: -0.9rem 0.6rem;
    height: 1.5rem;
    font-size: 12px;
    margin-left: 5px;

}
.button-uploadfile-toyota {
    background-color: orange;
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 1rem;
    padding: -0.9rem 0.6rem;
    height: 1.5rem;
    font-size: 12px;
    margin-left: 5px;

}
.button-addfile-lexus {
    background-color: #252525;
    border: none;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 1rem;
    padding: -0.9rem 0.6rem;
    height: 1.5rem;
    font-size: 14px;
}
.chips svg {
    color:white !important;
    height: 1rem;
}
.chips {
    max-height:4rem;
    overflow-y:scroll;
    margin-top:1rem;
}
.libFileTbl tbody {
    max-height: 550px;
    display: block;
    width: 99%;
    overflow-y: auto;
}
.libFileTbl tr {
    display: block;
}
.libFileTbl > tbody > tr {
    border: none!important;
    line-height: 2rem;
}
.libFileTbl > tbody > tr > td {
    padding-top: 1%;
    padding-bottom: 0%;
    word-break: break-all;
}
.lib-info-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0.3rem;
    cursor: pointer;
}

.nmscTabs .nav-tabs .nav-item{
    width:18% !important;
}

.nmscTabs.toyota .nav-tabs .nav-item a{
    border-color:transparent !important;
    color:black!important;
}

.nmscTabs.toyota .nav-tabs .nav-item a.nav-link.active{    
    color:#e50000 !important;    
}

.nmscTabs.lexus .nav-tabs .nav-item a{
    border-color:transparent !important;
}

.nmscTabs.lexus .nav-tabs .nav-item a.nav-link.active{
    color:black !important;
}

.nmscTabs .nav-tabs li.nav-item:first-child {
    width:35% !important;
}

.nmscTabs{
    padding : 0rem !important;
    border-width : 0px;
    font-size : 0.75rem;
    position: relative;
    width: 100%
}
.libraryRoot_underline{
    text-decoration: underline;
}
div.lexusChips {
    background-color:black !important;
}
div.toyotaChips {
    background-color:#e50000 !important;
}

/* .libraryTable {
    min-height: 32rem;
  }
  .rightPanel.libRightPanel{
    min-height: 596px !important;
  } */
   .libraryContainer{
    min-height:779px
 }
 .libraryTable-isMain{
    min-height: 680px
  }
.libraryTreeWrapper{
      min-height: 500px;
      max-height: 600px;
  }
  .canShrink.button-toyota{
      position: absolute;
     bottom:22px;
  } `, "",{"version":3,"sources":["webpack://./src/components/library/index.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,sBAAoB;IACpB,iBAAe;IAAf,iBAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI;AACJ;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,6BAA6B;IAC7B,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,UAAU;IACV,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;;AAEnB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,iCAAiC;AACrC;AACA;IACI,mCAAmC;AACvC;;AAEA;;;;;KAKK;GACF;IACC;CACH;CACA;IACG;EACF;AACF;MACM,iBAAiB;MACjB,iBAAiB;EACrB;EACA;MACI,kBAAkB;KACnB,WAAW;EACd","sourcesContent":[".folder-node label:before{\n    /* content: url('../../assets/images//calendar.png'); */\n    display: inline;\n    font-family: FontAwesome;\n    content: \"\\f07b\";\n    margin-right: 2px;\n    color: #ffc033;\n}\n.super-treeview > div > .super-treeview-node > .super-treeview-children-container{\n    border-left: 1px dashed #000;\n}\n.super-treeview > div > .super-treeview-node > .super-treeview-node-content > label {\n    text-overflow: unset;\n    overflow: unset;\n    white-space: pre-wrap;\n    font-size: 0.81rem;\n}\n.libraryTable {\n    min-height:23rem;\n}\n.library {\n    content: url('../../assets/images//delete.png')\n}\n.libraryContainer {\n    width: 100%;\n    background-color: white;\n    min-height: 500px;\n    border-top-right-radius: 15px;\n    border-bottom-right-radius: 15px;\n    border-bottom-left-radius: 15px;\n}\n.thickRightBorder{\n    border-right: 4px solid lightgray;\n}\n.bottomBorder {\n    border-bottom: 1px solid lightgray;\n}\n.super-treeview {\n    width: 99%;\n}\n.libraryTreeWrapper {\n    min-height: 400px;\n    max-height: 400px;\n    overflow: auto;\n}\n.libRightPanel {\n    width: 72%;\n    border: 1px solid lightgrey;\n    min-height: 760px!important;\n}\n.activeFolder {\n    color:#e50000 !important;\n}\n.libraryRoot {\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n}\n.black-font {\n    color: black!important;\n}\n.lib-add-icon {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n    margin-left: 0.75rem !important;\n    margin-top: 0px!important;\n}\n.button-addfile-toyota {\n    background-color: #e50000;\n    border: none;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 1rem;\n    padding: -0.9rem 0.6rem;\n    height: 1.5rem;\n    font-size: 14px;\n\n}\n.button-downloadfile-toyota {\n    background-color: blue;\n    border: none;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 1rem;\n    padding: -0.9rem 0.6rem;\n    height: 1.5rem;\n    font-size: 12px;\n    margin-left: 5px;\n\n}\n.button-uploadfile-toyota {\n    background-color: orange;\n    border: none;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 1rem;\n    padding: -0.9rem 0.6rem;\n    height: 1.5rem;\n    font-size: 12px;\n    margin-left: 5px;\n\n}\n.button-addfile-lexus {\n    background-color: #252525;\n    border: none;\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    cursor: pointer;\n    border-radius: 1rem;\n    padding: -0.9rem 0.6rem;\n    height: 1.5rem;\n    font-size: 14px;\n}\n.chips svg {\n    color:white !important;\n    height: 1rem;\n}\n.chips {\n    max-height:4rem;\n    overflow-y:scroll;\n    margin-top:1rem;\n}\n.libFileTbl tbody {\n    max-height: 550px;\n    display: block;\n    width: 99%;\n    overflow-y: auto;\n}\n.libFileTbl tr {\n    display: block;\n}\n.libFileTbl > tbody > tr {\n    border: none!important;\n    line-height: 2rem;\n}\n.libFileTbl > tbody > tr > td {\n    padding-top: 1%;\n    padding-bottom: 0%;\n    word-break: break-all;\n}\n.lib-info-icon {\n    background-image: url(\"../../assets/images//info.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0.3rem;\n    cursor: pointer;\n}\n\n.nmscTabs .nav-tabs .nav-item{\n    width:18% !important;\n}\n\n.nmscTabs.toyota .nav-tabs .nav-item a{\n    border-color:transparent !important;\n    color:black!important;\n}\n\n.nmscTabs.toyota .nav-tabs .nav-item a.nav-link.active{    \n    color:#e50000 !important;    \n}\n\n.nmscTabs.lexus .nav-tabs .nav-item a{\n    border-color:transparent !important;\n}\n\n.nmscTabs.lexus .nav-tabs .nav-item a.nav-link.active{\n    color:black !important;\n}\n\n.nmscTabs .nav-tabs li.nav-item:first-child {\n    width:35% !important;\n}\n\n.nmscTabs{\n    padding : 0rem !important;\n    border-width : 0px;\n    font-size : 0.75rem;\n    position: relative;\n    width: 100%\n}\n.libraryRoot_underline{\n    text-decoration: underline;\n}\ndiv.lexusChips {\n    background-color:black !important;\n}\ndiv.toyotaChips {\n    background-color:#e50000 !important;\n}\n\n/* .libraryTable {\n    min-height: 32rem;\n  }\n  .rightPanel.libRightPanel{\n    min-height: 596px !important;\n  } */\n   .libraryContainer{\n    min-height:779px\n }\n .libraryTable-isMain{\n    min-height: 680px\n  }\n.libraryTreeWrapper{\n      min-height: 500px;\n      max-height: 600px;\n  }\n  .canShrink.button-toyota{\n      position: absolute;\n     bottom:22px;\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
